import { useTranslation } from "react-i18next"
import { Fuel } from "lucide-react"
import { useFeatureFlagEnabled } from "posthog-js/react"
import BaseSidebarButton from "./BaseSidebarButton"
import { TAB_TYPES } from "@/reducers/tabsSlice"

const FuelReportSidebarButton = ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const enabled = Boolean(useFeatureFlagEnabled("fuel-report"))
  if (!enabled) return null
  return (
    <BaseSidebarButton
      tabName={TAB_TYPES.FUEL_REPORT}
      icon={Fuel}
      activeIcon={Fuel}
      tooltipText={t("app.sidebar.fuelReport")}
      className={className}
    />
  )
}

export default FuelReportSidebarButton
